import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';

export type ICustomWindow = Window;

function getWindow(): Window {
    return window;
}

@Injectable({
    providedIn: 'root',
})
export class WindowRefService {
    private _platform = inject(PLATFORM_ID);


    get NativeWindow(): ICustomWindow | undefined {
        return isPlatformBrowser(this._platform) ? getWindow() : undefined;
    }
}
